<template>
  <v-navigation-drawer
    v-model="drawer"
    permanent
    absolute
    fixed
    width="20%"
  >
    <v-list dense>
       <!-- <v-list-item
        link
        to="/docs/"
        :class="{ 'home--inactive': !isHome }"
      >
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <v-list-item
        v-for="entry in getEntriesSorted"
        :key="entry.fields.title"
        link
        :to="{
          name: 'docPage',
          params: { entryId: entry.sys.id }
        }"
      >
        <v-list-item-content>
          <v-list-item-title>{{ entry.fields.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      selectedEntry: {},
      drawer: true,
    }),
    computed: {
      ...mapGetters({
        getEntriesSorted: 'contentful/getEntriesSorted'
      }),
      isHome() {
        // return this.$route.path === '/docs' ? '' : ''
        // return this.$route.path === '/docs' || this.$route.path === '/docs/' ? 'v-list-item--active' : 'home--active'
        return this.$route.path === '/docs' || this.$route.path === '/docs/' ? true : false
      }
    },
  }
</script>

<style lang="scss" scoped>
  // .home--inactive:before {
  //   background-color: #ffffff !important;
  // }
</style>
